import SplashButton from './SplashButton';
import { ImQuotesLeft } from 'react-icons/im';
import Image from 'next/image';
import { Content } from '@prismicio/client';
import { ModalVideoPlayer } from './ModalVideoPlayer';
import { PrismicRichText } from '@prismicio/react';

interface FeaturedPartnerProps {
  data: Content.FeaturedPartnerDocument['data'];
  language: string;
}

const FeaturedPartner = ({ data }: FeaturedPartnerProps) => {
  return (
    <section className="py-6 pb-0 sm:pt-10">
      <h2 className="fade-up mb-8 px-4 text-center text-3xl font-normal leading-tight sm:mb-16 sm:text-4xl sm:font-light xl:text-5xl">
        {data.title}
      </h2>
      <div className="fade-up container mx-auto">
        <div className="flex flex-col items-center overflow-hidden md:flex-row md:items-stretch lg:overflow-visible">
          <div className="order-2 flex flex-col justify-start px-4 py-6 pt-0 text-center sm:mr-4 sm:space-y-2 sm:p-6 sm:pt-6 md:order-1 md:w-1/2 md:items-end md:text-right">
            <h3 className="text-2xl font-normal sm:text-3xl">
              <PrismicRichText
                field={data.name}
                components={{
                  strong: ({ children }) => (
                    <strong className="text-gradient-yellow">{children}</strong>
                  ),
                }}
              />
            </h3>

            <div className="text-base font-normal text-gray-500 sm:mt-4">
              <p>{data.company}</p>
              <p>{data.position}</p>
            </div>
            {/* Quote */}
            <blockquote className="relative max-w-[360px] pt-6 text-sm italic text-gray-600 sm:text-base">
              <ImQuotesLeft className="absolute top-[6px] text-3xl opacity-10 sm:-top-1 sm:text-4xl" />
              {data.quote}
            </blockquote>
            <div className="flex w-full flex-col justify-center pt-8 md:justify-end lg:w-auto lg:flex-row lg:space-x-4">
              <ModalVideoPlayer
                videoId={data.video_id || 'jYcv8FvE_Wg'}
                videoTitle="Featured Partner Video"
                videoLocation="Home Page"
              >
                <SplashButton
                  text={data.view_video_text || ''}
                  url="#"
                  size="md"
                  color="blue"
                  data-video={data.company}
                  className="ga-watchvideo min-w-[155px] text-center sm:min-w-[180px]"
                  preventNavigation={true}
                />
              </ModalVideoPlayer>
              <SplashButton
                text={data.view_case_study_text || ''}
                url={`${data.profile_link}`}
                size="md"
                color="transparentblue"
                className="ml-0 mt-4 lg:mt-0"
              />
            </div>
          </div>

          <div className="order-1 md:order-2 md:w-1/2">
            <ModalVideoPlayer
              videoId={data.video_id || 'jYcv8FvE_Wg'}
              videoTitle="Featured Partner Video"
              videoLocation="Home Page (iMac)"
            >
              <Image
                src={data.image.url || ''}
                alt="Profile"
                className="ga-watchvideo relative left-10 w-full object-cover transition-opacity hover:opacity-95 lg:h-full"
                width={600}
                height={450}
                sizes="(max-width: 768px) 100vw, 600px"
                data-video={data.company}
              />
            </ModalVideoPlayer>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedPartner;
